import { FormikErrors } from 'formik';
import { FormattedMessage } from 'react-intl';
import { IErrorMessage } from './errorMessage.type';

class ErrorMessageHelpers {
    public static isFormikError(message: IErrorMessage): message is FormikErrors<any> {
        return (
            !ErrorMessageHelpers.isString(message) &&
            !ErrorMessageHelpers.isMessageDescriptor(message) &&
            Boolean(Object.keys(message))
        );
    }

    public static isMessageDescriptor(
        message: IErrorMessage,
    ): message is FormattedMessage.MessageDescriptor {
        return typeof message !== 'string' && Boolean(message.id);
    }

    public static isFormattedMessageProps(
        message: IErrorMessage,
    ): message is FormattedMessage.Props {
        return typeof message !== 'string' && Boolean(message.id) && Boolean(message.values);
    }

    public static isString(message: IErrorMessage): message is string {
        return typeof message === 'string';
    }
}

export default ErrorMessageHelpers;
